import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/buttons';
import { InfoButton } from '@/components/buttons/InfoButton';
import { getExchangeInfo } from '@/components/dialogs/ExchangeCompoints/helpers';
import { ImageComponent } from '@/components/Image';
import { Modals } from '@/helpers/modals';
import { useNavigation } from '@/hooks/navigation';
import { useCompPointsRatesMoney } from '@/modules/common/hooks/useCompPointsRatesMoney';
import { useGetCommonStore, useModalsStore } from '@/store';
import { ScCompointsBanner } from './styled';

export const CompointsBanner = () => {
  const { navigate } = useNavigation();
  const { t } = useTranslation('bonuses');

  const open = useModalsStore.use.open();
  const useCommonStore = useGetCommonStore();

  const compPoints = useCommonStore.use.compPoints();

  const { data: compointsRatesMoney } = useCompPointsRatesMoney();

  const { userCompoints, minExchange, isExchangeAvailable } = useMemo(
    () => getExchangeInfo(compointsRatesMoney, compPoints?.chargeable?.points),
    [compointsRatesMoney, compPoints?.chargeable?.points]
  );

  return (
    <ScCompointsBanner isWithButton={isExchangeAvailable}>
      <ImageComponent
        alt="banner-char"
        className="banner-char"
        height={160}
        src="/bonuses/cp-banner-character.png"
        width={160}
      />
      <div className="info-btn">
        <InfoButton handleClick={() => navigate('/loyalty', true)} />
      </div>

      <div className="header">
        <div className="title">
          <div>{t('exchangePoints.exchangeablePoints')}</div>
          <div className="balance">{userCompoints} CP</div>
        </div>
        <div className="description">
          {t('exchangePoints.minExchange', { min: minExchange })}
        </div>
      </div>

      {isExchangeAvailable && (
        <Button
          disabled={(compPoints?.chargeable?.points || 0) < minExchange}
          onClick={() => open(Modals.ExchangeCompoints)}
          primary
          small
          wide
        >
          {t('exchangePoints.exchange')}
        </Button>
      )}
    </ScCompointsBanner>
  );
};
